export const Rule = ({ label, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} aria-hidden>
    <span className="h-px flex-1 bg-gradient-to-r from-transparent via-primary/40 to-primary/40" />
    <span className="h-1.5 w-1.5 rotate-45 border border-primary/70" />
    {label && <span className="eyebrow text-primary">{label}</span>}
    <span className="h-1.5 w-1.5 rotate-45 border border-primary/70" />
    <span className="h-px flex-1 bg-gradient-to-l from-transparent via-primary/40 to-primary/40" />
  </div>
);

export const CompassRose = ({ className = "" }) => (
  <svg
    viewBox="0 0 400 400"
    className={className}
    fill="none"
    stroke="hsl(var(--primary))"
    aria-hidden
  >
    <circle cx="200" cy="200" r="196" strokeWidth="0.8" strokeOpacity="0.5" />
    <circle cx="200" cy="200" r="170" strokeWidth="0.6" strokeDasharray="2 6" strokeOpacity="0.6" />
    <circle cx="200" cy="200" r="118" strokeWidth="0.6" strokeOpacity="0.5" />
    <circle cx="200" cy="200" r="24" strokeWidth="0.8" />
    <g strokeWidth="0.7" strokeOpacity="0.7">
      {Array.from({ length: 72 }).map((_, i) => {
        const a = (i * Math.PI) / 36;
        const long = i % 6 === 0;
        const r1 = 196;
        const r2 = long ? 182 : 190;
        return (
          <line
            key={i}
            x1={200 + Math.cos(a) * r1}
            y1={200 + Math.sin(a) * r1}
            x2={200 + Math.cos(a) * r2}
            y2={200 + Math.sin(a) * r2}
          />
        );
      })}
    </g>
    <g strokeWidth="0.9" fill="hsl(var(--primary))" fillOpacity="0.12">
      <path d="M200 40 L214 186 L200 200 L186 186 Z" />
      <path d="M200 360 L214 214 L200 200 L186 214 Z" />
      <path d="M40 200 L186 186 L200 200 L186 214 Z" />
      <path d="M360 200 L214 186 L200 200 L214 214 Z" />
    </g>
    <g strokeWidth="0.7" fill="hsl(var(--primary))" fillOpacity="0.06">
      <path d="M92 92 L192 192 L200 200 L192 192 L184 176 Z" />
      <path d="M308 92 L208 192 L200 200 L216 176 Z" />
      <path d="M92 308 L192 208 L200 200 L184 224 Z" />
      <path d="M308 308 L208 208 L200 200 L216 224 Z" />
    </g>
    <path d="M200 60 l-6 14 6-4 6 4z" fill="hsl(var(--primary))" stroke="none" />
  </svg>
);

const ROMAN = [
  [1000, "M"], [900, "CM"], [500, "D"], [400, "CD"], [100, "C"], [90, "XC"],
  [50, "L"], [40, "XL"], [10, "X"], [9, "IX"], [5, "V"], [4, "IV"], [1, "I"],
];
export const roman = (n) => {
  let out = "";
  for (const [v, s] of ROMAN) while (n >= v) { out += s; n -= v; }
  return out || "0";
};
